import { createContext, useContext, useEffect } from "react";

import { Tenant } from "types/entities";

interface TenantContextValue {
  tenant: Tenant;
  isLoading: boolean;
  onChangeVersion: (e: any) => void;
  onLockVersion: (e: any) => void;
}

export const CurrentTenantContext = createContext<TenantContextValue | undefined>(undefined);

export const useCurrentTenant = () => {
  const { tenant } = useContext(CurrentTenantContext);
  return tenant;
};

const useChangeVersion = () => {
  const { onChangeVersion } = useContext(CurrentTenantContext);
  return onChangeVersion;
};

export const useLockVersion = () => {
  const { onLockVersion } = useContext(CurrentTenantContext);
  return onLockVersion;
};

const useWithVersion = (version) => {
  const changeVersion = useChangeVersion();
  const { version_number } = useCurrentTenant();
  useEffect(() => {
    changeVersion(version);
  }, [changeVersion, version, version_number]);
};

export const useWithHeadVersion = () => useWithVersion("head");
export const useWithCurrentVersion = () => useWithVersion("current");
